import { Controller } from "@hotwired/stimulus";
import { flip, computePosition, offset } from "@floating-ui/dom";

// Connects to data-controller="tooltip"
export default class extends Controller {
  static values = {
    content: String,
    placement: { type: String, default: "left" },
  };

  async connect() {
    this.tooltip = document.createElement("div");
    this.tooltip.append(document.createTextNode(this.contentValue));
    this.tooltip.classList.add("tooltip");
    this.tooltip.setAttribute("aria-hidden", "true");
    this.tooltip.setAttribute("role", "tooltip");
    this.tooltip.setAttribute(
      "id",
      this.element.getAttribute("aria-describedby"),
    );
    this.element.insertAdjacentElement("afterend", this.tooltip);
  }

  show() {
    this.tooltip.setAttribute("aria-hidden", "false");
    computePosition(this.element, this.tooltip, {
      placement: this.placementValue,
      middleware: [offset(5), flip()],
    }).then(({ x, y, placement, middlewareData }) => {
      Object.assign(this.tooltip.style, {
        left: `${x}px`,
        top: `${y}px`,
      });
    });
  }

  hide() {
    this.tooltip.setAttribute("aria-hidden", "true");
  }
}
